export const SET_NAVIGATOR_ENTITIES = 'SET_NAVIGATOR_ENTITIES';
export const SET_NAVIGATOR_ORGS = 'SET_NAVIGATOR_ORGS';
